import { NavLink } from "hooks/useCustomNavigation";
import "./index.scss";

export const NavbarItem = ({
  path,
  label,
  logId,
  onClick,
  isExternalLink = false,
  isOverlay
}) => {
  const testId = String(label).toLowerCase();

  return (
    <li className={`navbar-item ${isOverlay ? "overlay" : ""}`}>
      {onClick ? (
        <button
          data-logid={logId}
          data-testid={testId}
          className="button"
          onClick={onClick}
        >
          {label}
        </button>
      ) : isExternalLink ? (
        <a
          data-logid={logId}
          data-testid={testId}
          className="anchor"
          href={path}
        >
          {label}
        </a>
      ) : (
        <NavLink
          to={path}
          data-logid={logId}
          data-testid={testId}
          className="anchor"
        >
          {label}
        </NavLink>
      )}
    </li>
  );
};
